export default __webpack_public_path__ + "static/media/Question.cf7bc458.svg";